<template>
    <div>
        <top :keyword="''" :tab="'policy'"></top>
        <div class="main-1200">
            <div class="mt20">
                <div class="gleft">
                    <div class="m-slide" id="slideBanner">
                        <div class="bd">
                            <ul>
                                <li>
                                    <el-carousel indicator-position="none" :autoplay="false">
                                        <el-carousel-item
                                            v-for="(a,index) in picArticles"
                                            :key="index"
                                        >
                                            <router-link :to="'/policy/'+ a.id" :title="a.title">
                                                <pic :src="a.coverImageUrl" />
                                                <p>
                                                    <i></i>
                                                    <a
                                                        target="_blank"
                                                        :title="a.title"
                                                    >{{ a.title }}</a>
                                                </p>
                                            </router-link>
                                        </el-carousel-item>
                                    </el-carousel>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="grighrt">
                    <div id="newsList">
                        <div class="g-tab-pad" style="height:293px;">
                            <ul class="news-list news_list1">
                                <li v-for="a in articles" :key="a.id">
                                    <!-- <a :href="articleUrl(a)">-->
                                    <a :href="a.path" :target="a.state" :title="a.title">
                                        <span class="news_left" :class="{top : a.top}">{{ a.title }}</span>
                                        <span class="news_right">{{ formatDate(a.createDate) }}</span>
                                    </a>
                                    <!-- </a> -->
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="policy-title">
            <span>
                <font>全部文件</font>
            </span>
        </div>
        <div class="all" style="width: 1200px !important;margin-right: auto;margin-left: auto;">
            <div
                v-for="(a, index) in page2"
                :key="index"
                style="width: 50%;float: left;"
                v-if="index < 9"
            >
                <div class="column-inner">
                    <div class="policy-archive">
                        <!-- <a :href="articleUrl(a)"> -->
                        <a :href="a.path" :target="a.state" :title="a.title">
                            <div class="caption">
                                <div class="headline">{{ a.title }}</div>
                                <div class="abstract">{{ a.summary }}</div>
                                <div class="time">
                                    <span>
                                        <i class="el-icon-time" />
                                        {{ formatDate(a.createDate) }}
                                    </span>
                                    <span>
                                        <i class="el-icon-view" />
                                        {{ a.viewCount }}
                                    </span>
                                </div>
                                <div class="in">
                                    <i class="el-icon-arrow-right" />
                                </div>
                            </div>
                            <!-- </a> -->
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <bottom style="position:relative;bottom:-50px;"></bottom>
    </div>
</template>
<script>
import top from './top'
import bottom from './bottom'

export default {
    name: 'policy',
    data() {
        return {
            picArticles: [],
            articles: [],
            page2: []
        }
    },
    computed: {},
    methods: {
        articleUrl: function(article) {},
        formatDate: function(date) {
            date = new Date(date)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()
            if (month < 10) {
                month = '0' + month
            }
            if (day < 10) {
                day = '0' + day
            }
            return year + '-' + month + '-' + day
        }
    },
    created() {
        let qs = require('qs')
        let data = {
            pageSize: 10,
            pageNum: 1,
            platformId: localStorage.getItem('datas'),
            code: 'policy'
        }
        this.$http
            .post(this.$cmsPath + '/column/api/?' + qs.stringify(data))
            .then(result => {
                result = result.data
                if (result.success) {
                    result.data.content.map(item => {
                        if (item.coverImageUrl) {
                            this.picArticles.push(item)
                        } else {
                            this.articles.push(item)
                        }
                    })
                    this.articles.map(item=>{
                        if(item.type == 1){
                            item.path = item.href
                            item.state = '_block'
                        }else{
                            item.path = '/policy/'+item.id
                        }
                    })
                }
            })
        data = {
            pageSize: 10,
            pageNum: 2,
            platformId: localStorage.getItem('datas'),
            code: 'policy'
        }
        this.$http
            .post(this.$cmsPath + '/column/api/?' + qs.stringify(data))
            .then(result => {
                result = result.data
                if (result.success) {
                    this.page2 = result.content
                    this.page2.map(item=>{
                        if(item.type == 1){
                            item.path = item.href
                            item.state = '_block'
                        }else{
                            item.path = '/policy/'+item.id
                        }
                    })
                }
            })
    },
    components: {
        bottom: bottom,
        top: top
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';
.headline {
    height: 30px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    text-align: left;
}
.abstract {
    height: 26px !important;
    text-align: left;
    padding-left: 2px;
}
.time {
    text-align: left;
    margin-top: 5px;
}
.in {
    position: absolute;
    right: 8px;
    font-size: 40px;
    color: #ccc;
    top: 40px;
}
.caption:hover .in {
    color: #3ab57f;
}
.el-carousel__container {
    height: 400px !important;
}
.el-carousel,
.el-carousel--horizontal {
    height: 400px;
}
.el-carousel__item {
    height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/policy.vue